export const ExperimentAPINames = {
  ArchiveWall: "Archive Wall",
  ArticleHumanAI: "Article 2.0 Human VS AI",
  ArticleRecirculationWidgets: "Article 2.0 Recirculation Widgets",
};
